import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Button, Col, Divider, Drawer, Input, Radio, Row, Select, Typography, Tabs, TimePicker, Popconfirm, message, Spin, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import DynamicTable from '../../../../components/DynamicTable'
import Utils from '../../../../utils/Utils'
import shopSrc from '../../shopSrc'
const { Title } = Typography
const { TabPane } = Tabs
const { Option } = Select

const FieldLabel = ({ label, tooltip }) => (
  <div className={'title-space-field'}>
    <span>{label}</span>
    <Tooltip title={tooltip}>
      <QuestionCircleOutlined style={{ marginLeft: 6, fontSize: 14, color: '#999' }} />
    </Tooltip>
  </div>
)


function ShopsDrawer(props) {
  const [dataSource, setDataSource] = useState([])
  const [name, setName] = useState('')
  const [enterpriseId, setEnterpriseId] = useState('')
  const [address, setAddress] = useState('')
  const [pettyCashAmount, setPettyCashAmount] = useState('')
  const [storeTypeId, setStoreTypeId] = useState('')
  const [storeChainId, setStoreChainId] = useState('')
  const [storeFlagId, setStoreFlagId] = useState('')
  const [locationTypeId, setLocationTypeId] = useState('')
  const [storeFormatId, setStoreFormatId] = useState('')
  const [size, setSize] = useState('')
  const [socioeconomicLevelId, setSocioeconomicLevelId] = useState('')
  const [stateId, setStateId] = useState('')
  const [municipalityId, setMunicipalityId] = useState('')
  const [zoneId, setZoneId] = useState('')
  const [latitute, setLatitute] = useState('')
  const [longitude, setLongitude] = useState('')
  const [enterprises, setEnterprises] = useState([])
  const [storeType, setStoreType] = useState([])
  const [storeChain, setStoreChain] = useState([])
  const [storeFlag, setStoreFlag] = useState([])
  const [storeLocation, setStoreLocation] = useState([])
  const [storeFormat, setStoreFormat] = useState([])
  const [storeSocioeconomicLevel, setStoreSocioeconomicLevel] = useState([])
  const [storeState, setStoreState] = useState([])
  const [storeZone, setStoreZone] = useState([])
  const [storeMunicipality, setStoreMunicipality] = useState([])
  const [loadingField, setLoadingField] = useState(true)
  const [loading, setLoading] = useState(true)
  const [municipality, setMunicipality] = useState(true)
  const [zone, setZone] = useState(true)
  const [codigo_establecimiento, setCodigoEstablecimiento] = useState(true)
  const [postalCode, setPostalCode] = useState('')
  const [allowSalesWithNegativeStock, setAllowSalesWithNegativeStock] = useState(false)
  const [allowDeliveryOrder, setAllowFel] = useState(false)  

  const loadStoreInfo = () => {
    setName(props.copy ? props.editData._shop + '_copia' : props.edit ? props.editData._shop : '')
    setEnterpriseId(props.edit ? props.editData._enterprise_id : null)
    setAddress(props.edit ? props.editData._address : '')
    setPettyCashAmount(props.edit ? props.editData._petty_cash_amount : '')
    setStoreTypeId(props.edit ? props.editData._store_type_id : null)
    setStoreChainId(props.edit ? props.editData._store_chain_id : null)
    setStoreFlagId(props.edit ? props.editData._store_flag_id : null)
    setLocationTypeId(props.edit ? props.editData._location_type_id : null)
    setStoreFormatId(props.edit ? props.editData._store_format_id : null)
    setSize(props.edit ? props.editData._size : '')
    setSocioeconomicLevelId(props.edit ? props.editData._socioeconomic_level_id : null)
    setStateId(props.edit ? props.editData._state_id : null)
    setMunicipalityId(props.edit ? props.editData._municipality_id : null)
    setZoneId(props.edit ? props.editData._zone_id : null)
    setLatitute(props.edit ? props.editData._latitute : '')
    setLongitude(props.edit ? props.editData._longitude : '')
    setCodigoEstablecimiento(props.edit ? props.editData._codigo_establecimiento : '')
    setPostalCode(props.edit ? props.editData._postal_code : '')
    setAllowSalesWithNegativeStock(props.edit ? props.editData._allow_sales_with_negative_stock : false)
    setAllowFel(props.edit ? props.editData._allow_delivery_order : false)
  }

  useEffect(() => {
    loadStoreInfo()
    if (props.visible) {
      onSearchEnterprise('')
      onSearchStoreType('')
      onSearchStoreChain('')
      onSearchStoreFlag('')
      onSearchStoreLocation('')
      onSearchStoreFormat('')
      onSearchStoreSocioeconomicLevel('')
      onSearchStoreState('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  useEffect(() => {
    let turns = JSON.stringify(props.turns)
    setDataSource(JSON.parse(turns))
    setLoading(false)
  }, [props.turns])

  const onSearchEnterprise = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getEnterpriseOption(val, excludeChars, 'desc')
      .then(response => {
        setEnterprises(response.data.data)
        setLoadingField(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de empresa')
      })
  }

  const onSearchStoreType = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getStoreTypeOption(val, excludeChars, 'desc')
      .then(response => {
        setStoreType(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de tipo de negocio')
      })
  }

  const onSearchStoreChain = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getStoreChainOption(val, excludeChars, 'desc')
      .then(response => {
        setStoreChain(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de Cadena')
      })
  }

  const onSearchStoreFlag = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getStoreFlag(val, excludeChars, 'desc')
      .then(response => {
        setStoreFlag(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de Bandera')
      })
  }

  const onSearchStoreLocation = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getLocation(val, excludeChars, 'desc')
      .then(response => {
        setStoreLocation(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de Tipo de ubicación')
      })
  }

  const onSearchStoreFormat = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getStoreFormat(val, excludeChars, 'desc')
      .then(response => {
        setStoreFormat(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de formato de tienda')
      })
  }

  const onSearchStoreSocioeconomicLevel = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getSocioeconomicLevel(val, excludeChars, 'desc')
      .then(response => {
        setStoreSocioeconomicLevel(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de nivel socio-economico')
      })
  }

  const onSearchStoreState = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getState(val, excludeChars, 'desc')
      .then(response => {
        setStoreState(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de Departamento/Estado')
      })
  }

  const onSearchStoreMunicipality = (val, id) => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getMunicipalities(val, id, excludeChars, 'desc')
      .then(response => {
        setStoreMunicipality(response.data.data)
        setMunicipality(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de Municipio/Localidad')
      })
  }

  const onSearchStoreZone = (val, id) => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getZoneByMunicipalityId(val, id, excludeChars, 'desc')
      .then(response => {
        setStoreZone(response.data.data)
        setZone(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de Zona/Barrio')
      })
  }

  const handlerAdd = () => {
    setDataSource(
      dataSource.concat([
        {
          name: '',
          start_time: '',
          end_time: '',
        },
      ])
    )
  }

  const checkErrors = res => {
    if (res.errors && Object.keys(res.errors)?.length > 0) {
      Object.keys(res.errors).map(key => {
        switch (key) {
          case 'name':
            message.error(res.errors[key][0].replace('name', 'Nombre'))
            break
          default:
            message.error(res.errors[key])
            break
        }
        return null
      })
      return false
    } else {
      return true
    }
  }

  const saveTurns = () => {
    let _valida = false
    if (dataSource.length === 0) {
      return message.warning('Debes completar la información.')
    }
    dataSource.map(dataSrc => {
      if (
        [dataSrc.name, dataSrc.start_time, dataSrc.end_time].includes(undefined) ||
        [dataSrc.name, dataSrc.start_time, dataSrc.end_time].includes('')
      ) {
        _valida = true
      }
      return true
    })
    if (_valida) return message.warning('Debes completar la información.')

    setLoading(true)
    let turns = async () =>
      await dataSource.map(validateMethod => {
        if (validateMethod.key === undefined) {
          let dataToSave = {
            name: validateMethod.name,
            start_time: validateMethod.start_time,
            end_time: validateMethod.end_time,
            store_id: validateMethod.store_id,
            is_active: validateMethod.is_active,
            is_default: validateMethod.is_default,
          }
          return shopSrc
            .saveTurns(dataToSave)
            .then(res => checkErrors(res))
            .catch(err => {
              console.log(err)
              message.error('No se pudo guarda la información de turnos.')
              setLoading(false)
            })
        } else {
          let dataToUpdate = {
            name: validateMethod.name,
            start_time: validateMethod.start_time,
            end_time: validateMethod.end_time,
            store_id: validateMethod.store_id,
            is_active: validateMethod.is_active,
            is_default: validateMethod.is_default,
          }
          return shopSrc
            .updateTurns(validateMethod.key, dataToUpdate)
            .then(res => checkErrors(res))
            .catch(err => {
              console.log(err)
              message.error('No se pudo actualizar la información de turnos.')
              setLoading(false)
            })
        }
      })

    turns().then(async res => {
      let boolean = await Promise.all(res)
      if (!boolean.includes(false)) {
        message.success('Turnos actualizados.')
        props.saveTurns()
      }
      setLoading(false)
    })
  }

  const deleteItem = index => {
    setDataSource(dataSource.filter((item, ind) => ind !== index))

    if (dataSource.filter((item, ind) => ind === index)[0].key !== undefined) {
      shopSrc.removeTurns(dataSource.filter((item, ind) => ind === index)[0].key).then(response => {
        message.success(`Turno elminado.`)
      })
    } else {
      message.success(`Turno elminado.`)
    }
  }

  const handleChangeValues = (value, indexRow, key, type) => {
    let tmpState = [...dataSource]
    switch (type) {
      case 'name':
        tmpState[indexRow].name = value
        tmpState[indexRow].store_id = props.editData._id
        tmpState[indexRow].is_active = 1
        tmpState[indexRow].is_default = 0
        break
      case 'startDate':
        tmpState[indexRow].start_time = value
        tmpState[indexRow].store_id = props.editData._id
        tmpState[indexRow].is_active = 1
        tmpState[indexRow].is_default = 0
        break
      case 'endDate':
        tmpState[indexRow].end_time = value
        tmpState[indexRow].store_id = props.editData._id
        tmpState[indexRow].is_active = 1
        tmpState[indexRow].is_default = 0
        break
      default:
        break
    }
    setDataSource(tmpState)
  }

  const columns = [
    {
      title: 'Nombre*',
      dataIndex: 'name', // Field that is goint to be rendered
      key: 'name',
      render: (text, record, indexRow) => (
        <Input
          value={record.name}
          size={'large'}
          placeholder={'Ingresa nombre'}
          onChange={event => handleChangeValues(event.target.value, indexRow, record._id, 'name')}
        />
      ),
    },
    {
      title: 'Inicio',
      dataIndex: 'start_time', // Field that is goint to be rendered
      key: 'start_time',
      render: (text, record, indexRow) => (
        <TimePicker
          value={record.start_time !== '' ? moment(record.start_time, 'HH:mm:ss') : ''}
          className={'single-time-picker'}
          placeholder={'00:00'}
          style={{ width: '100%' }}
          format={'HH:mm:ss'}
          onChange={(event, stringDate) => handleChangeValues(stringDate, indexRow, record._id, 'startDate')}
        />
      ),
    },
    {
      title: 'Finalización',
      dataIndex: 'end_time', // Field that is goint to be rendered
      key: 'end_time',
      render: (text, record, indexRow) => (
        <TimePicker
          value={record.end_time !== '' ? moment(record.end_time, 'HH:mm:ss') : ''}
          F
          className={'single-time-picker'}
          placeholder={'00:00'}
          style={{ width: '100%' }}
          format={'HH:mm:ss'}
          onChange={(event, stringDate) => handleChangeValues(stringDate, indexRow, record._id, 'endDate')}
        />
      ),
    },
    {
      title: '',
      dataIndex: '_name',
      render: (text, record, index) => (
        <>
          <Popconfirm title={'Seguro de eliminar?'} onConfirm={() => deleteItem(index)}>
            <span style={{ color: 'red' }}>Eliminar</span>
          </Popconfirm>
        </>
      ),
    },
  ]

  const saveStoreData = () => {
    if (!Utils.deepEqualCompare(dataSource, props.turns)) {
      return message.warning('Existen cambios en los turnos, guárdalos antes de continuar')
    }
    if (
      [
        name,
        enterpriseId,
        address,
        pettyCashAmount,
        storeTypeId,
        storeChainId,
        storeFlagId,
        locationTypeId,
        storeFormatId,
        size,
        socioeconomicLevelId,
        stateId,
        municipalityId,
        zoneId,
        latitute,
        longitude,
      ].includes('') ||
      [
        name,
        enterpriseId,
        address,
        pettyCashAmount,
        storeTypeId,
        storeChainId,
        storeFlagId,
        locationTypeId,
        storeFormatId,
        size,
        socioeconomicLevelId,
        stateId,
        municipalityId,
        zoneId,
        latitute,
        longitude,
      ].includes(null)
    ) {
      return message.warning('Todos los campos son obligatorios')
    }

    let data = {
      id: props.edit ? props.editData._id : null,
      name: name,
      company_id: enterpriseId,
      address: address,
      petty_cash_amount: pettyCashAmount,
      store_type_id: storeTypeId,
      store_chain_id: storeChainId,
      store_flag_id: storeFlagId,
      location_type_id: locationTypeId,
      store_format_id: storeFormatId,
      size: size,
      socioeconomic_level_id: socioeconomicLevelId,
      state_id: stateId,
      municipality_id: municipalityId,
      zone_id: zoneId,
      latitute: latitute,
      longitude: longitude,
      codigo_establecimiento: codigo_establecimiento,
      postal_code: postalCode,
      allow_sales_with_negative_stock: allowSalesWithNegativeStock,
      allow_delivery_order: allowDeliveryOrder
    }

    if (props.copy) {
      props.saveButton(data, false)
    } else {
      props.saveButton(data, props.edit)
    }
  }

  const onCancel = () => {
    props.cancelButton()
    setStoreMunicipality(null)
    setStoreZone(null)
    setMunicipality(true)
    setZone(true)
  }

  return (
    <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
      {
        props.copy ? <Title>{'Nueva Tienda'}</Title> : <Title> {props.edit ? 'Editar Tienda' : 'Nueva Tienda'}</Title>
      }
      <Divider className={'divider-custom-margins-users'} />
      <Tabs id={'tenderoShopTabs'} className="shop-drawer" defaultActiveKey="1">
        <TabPane tab="Datos" key="1">
          <Spin spinning={loadingField}>
            <div className={'shops-container-tabs'}>
              {/*Fields section*/}
              <Row className={'section-space-field'} gutter={16}>
                <Col xs={12} sm={12} md={12} lg={12}>
                <FieldLabel
                    label="Nombre*"
                    tooltip="Nombre que se le dara a la farmacia, negocio o tienda."
                  />                          
                  <Input value={name} placeholder={'Nombre'} size={'large'} onChange={value => setName(value.target.value)} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                <FieldLabel
                    label="Empresa*"
                    tooltip="Empresa a la que pertenece la tienda. Afecta reportes y agrupación de datos."
                  />
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    className={'single-select'}
                    placeholder={'Elegir empresa'}
                    size={'large'}
                    style={{ width: '100%' }}
                    value={enterpriseId}
                    onSearch={onSearchEnterprise}
                    onChange={value => setEnterpriseId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {enterprises &&
                      enterprises.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={24} sm={24} md={24} lg={24}>
                <FieldLabel
                    label="Dirección*"
                    tooltip="Dirección física de la tienda. Se utiliza para ubicaciones y documentación."
                  />                  <Input value={address} placeholder={'Escribir dirección'} size={'large'} onChange={value => setAddress(value.target.value)} />
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Monto en caja chica*"
                    tooltip="Monto máximo de efectivo que se maneja en la caja chica de esta tienda."
                  />                  
                  <Input
                    disabled={props.edit && props.editData._petty_cash_amount}
                    value={pettyCashAmount}
                    placeholder={'Escribir monto'}
                    size={'large'}
                    type={'number'}
                    onChange={value => setPettyCashAmount(value.target.value)}
                  />
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Tipo de negocio*"
                    tooltip="Clasificación general del negocio (ej. supermercado, farmacia, etc.)."
                  />                  
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreType}
                    value={storeTypeId}
                    className={'single-select'}
                    placeholder={'Seleccionar tipo'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => setStoreTypeId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeType &&
                      storeType.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Cadena*"
                    tooltip="Grupo al que pertenece la farmacia, como Corporación o cadena comercial."
                  />      
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreChain}
                    value={storeChainId}
                    className={'single-select'}
                    placeholder={'Seleccionar cadena'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => setStoreChainId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeChain &&
                      storeChain.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Bandera*"
                    tooltip="Marca comercial con la que opera la farmacia. Puede ser distinta a la cadena principal en casos de franquicias o submarcas."
                  />                     
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreFlag}
                    value={storeFlagId}
                    className={'single-select'}
                    placeholder={'Seleccionar bandera'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => setStoreFlagId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeFlag &&
                      storeFlag.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Tipo de Ubicación*"
                    tooltip="Clasificación del entorno donde está ubicada la farmacia (centro comercial, local a pie de calle, zona residencial, zona comercial, área rural, etc.). Esto afecta tránsito de clientes y estrategias de operación.."
                  />                       
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreLocation}
                    value={locationTypeId}
                    className={'single-select'}
                    placeholder={'Seleccionar ubicacion'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => setLocationTypeId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeLocation &&
                      storeLocation.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Formato de tienda*"
                    tooltip="Modelo de operación de la farmacia."
                  />                      
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreFormat}
                    value={storeFormatId}
                    className={'single-select'}
                    placeholder={'Seleccionar formato'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => setStoreFormatId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeFormat &&
                      storeFormat.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Tamaño de tienda*"
                    tooltip="Tamaño total del local en metros cuadrados. Se utiliza para clasificación comercial, capacidad de exhibición y estándares operativos."
                  />                  
                  <Input
                    value={size}
                    placeholder={'Escribir tamaño'}
                    size={'large'}
                    type={'number'}
                    onChange={value => setSize(value.target.value)}
                  />
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Nivel Socioeconómico*"
                    tooltip="Segmento socioeconómico predominante de la zona donde opera la farmacia (bajo, medio, alto). Ayuda a definir surtido, precios y comportamiento del cliente."
                  />                     
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreSocioeconomicLevel}
                    value={socioeconomicLevelId}
                    className={'single-select'}
                    placeholder={'Elegir nivel socioeconómico'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => setSocioeconomicLevelId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeSocioeconomicLevel &&
                      storeSocioeconomicLevel.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Departamento*"
                    tooltip="Departamento donde se encuentra ubicada la farmacia o tienda."
                  />                  
                  <Select
                    disabled={loadingField}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreState}
                    value={stateId}
                    className={'single-select'}
                    placeholder={'Seleccionar departamento/estado'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => {
                      setStateId(value)
                      setMunicipalityId(null)
                      setZoneId(null)
                      setMunicipality(true)
                      setZone(true)
                      onSearchStoreMunicipality('', value)
                    }}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeState &&
                      storeState.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Municipio/Localidad*"
                    tooltip="Municipio o localidad donde está físicamente ubicada la farmacia. Se utiliza para logística, informes y regulaciones fiscales."
                  />                     
                  <Select
                    disabled={loadingField || municipality}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreMunicipality}
                    value={municipalityId}
                    className={'single-select'}
                    placeholder={'Seleccionar municipio/localidad'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => {
                      setMunicipalityId(value)
                      setZoneId(null)
                      setZone(true)
                      onSearchStoreZone('', value)
                    }}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeMunicipality &&
                      storeMunicipality.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Zona/Barrio*"
                    tooltip="Sector dentro del municipio donde se encuentra la farmacia (zona, barrio o colonia). Permite geolocalización precisa y análisis de comportamiento del mercado."
                  />                     
                  <Select
                    disabled={loadingField || zone}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchStoreZone}
                    value={zoneId}
                    className={'single-select'}
                    placeholder={'Seleccionar zona/barrio'}
                    size={'large'}
                    style={{ width: '100%' }}
                    onChange={value => setZoneId(value)}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {storeZone &&
                      storeZone.map(data => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Latitud*"
                    tooltip="Coordenada geográfica (latitud) de la tienda para mapas y geolocalización."
                  />                  
                  <Input
                    value={latitute}
                    placeholder={'Escribir latitud'}
                    size={'large'}
                    type={'number'}
                    onChange={value => setLatitute(value.target.value)}
                  />
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                  label="Longitud*"
                  tooltip="Coordenada geográfica (longitud) de la tienda para mapas y geolocalización."
                />                  
                <Input
                    value={longitude}
                    placeholder={'Escribir longitud'}
                    size={'large'}
                    type={'number'}
                    onChange={value => setLongitude(value.target.value)}
                  />
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Código establecimiento*"
                    tooltip="Código único del establecimiento asignado por Digifact para facturación electrónica GT."
                  />
                    <Input
                    value={codigo_establecimiento}
                    placeholder={'Escribir código establecimiento'}
                    size={'large'}
                    type={'number'}
                    onChange={value => setCodigoEstablecimiento(value.target.value)}
                  />
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                <FieldLabel
                    label="Código postal"
                    tooltip="Código postal del establecimiento asignado por Digifact (tabla de establecimientos GT)."
                  />
                    <Input
                    value={postalCode}
                    placeholder={'Escribir código postal'}
                    size={'large'}
                    onChange={value => setPostalCode(value.target.value)}
                  />
                </Col>
              </Row>
              {/*End Fields section*/}

              {/*Radio button section*/}
              {//!(auth.role_id > 1) && 
                (
                  <>
                    <Row gutter={16} className={'section-space-list'}>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <span className={'label-bold-500 ratio-button-labels'}>¿Podrá facturar en negativo?</span>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Radio.Group
                          className={'radio-group'}
                          optionType="button"
                          buttonStyle="solid"
                          size={'large'}
                          value={allowSalesWithNegativeStock}
                          onChange={value => setAllowSalesWithNegativeStock(value.target.value)}
                        >
                          <Radio.Button value={false}>No</Radio.Button>
                          <Radio.Button value={true}>Sí</Radio.Button>
                        </Radio.Group>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} />
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <span className={'label-bold-500 ratio-button-labels'}>¿Podrá ver/imprimir Comanda de entrega?</span>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Radio.Group
                          className={'radio-group'}
                          optionType="button"
                          buttonStyle="solid"
                          size={'large'}
                          value={allowDeliveryOrder}
                          onChange={value => setAllowFel(value.target.value)}
                        >
                          <Radio.Button value={false}>No</Radio.Button>
                          <Radio.Button value={true}>Sí</Radio.Button>
                        </Radio.Group>
                      </Col>
                    </Row>
                  </>
                )}
              {/*End Radio button section*/}

            </div>
          </Spin>
        </TabPane>
        <TabPane disabled={!props.edit} tab="Turnos" key="2">
          <Spin spinning={loading}>
            <div className={'shops-container-tabs'}>
              <DynamicTable columns={columns} data={dataSource} />
              <Row gutter={16} className={'section-space-list'}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Button disabled={!props.edit} type="dashed" className={'shop-add-turn'} onClick={handlerAdd}>
                    Agregar turno
                  </Button>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Button disabled={!props.edit} className={'shop-add-turn'} onClick={saveTurns}>
                    Guardar turno
                  </Button>
                </Col>
              </Row>
            </div>
          </Spin>
        </TabPane>
      </Tabs>
      <Divider className={'divider-custom-margins-users'} />
      {/*Footer buttons section*/}
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <div>
              <Button onClick={onCancel} type={'link'} className="cancel-button">
                Cancelar
              </Button>
              <Button loading={loadingField} className="title-tendero new-button" onClick={() => saveStoreData()}>
                Guardar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      {/*End Footer buttons section*/}
    </Drawer>
  )
}
export default ShopsDrawer
